import { getFiletype, type FileType } from '@/modules/Project/Fields/utils/file'
import { computed, type ComputedRef, type Ref } from 'vue'

/**
 * Given a filename or URL, returns the type of file it is..
 */
export const useFileType = (filename: Ref<string | undefined | null>): ComputedRef<FileType> =>
  computed(() => (typeof filename.value === 'string' ? getFiletype(filename.value) : undefined))
